const ancillariesCatalog = new Set();

ancillariesCatalog
    .add('continuance-nag-add-bag-button')
    .add('NAGS:BAGGAGE_ON_CONTINUE:REJECTION')
    .add('NAGS:SEATS_ON_CONTINUE:REJECTION')
    .add('NAGS:SEATS_ON_CONTINUE:ACCEPTANCE')
    .add('NAGS:BAGGAGE_ON_CONTINUE:ACCEPTANCE')
    .add('ancillaries_continue_button_load')
    .add('ancillaries_continue_button_click')
    .add('continuance-nag-add-seat-button');

export default ancillariesCatalog;
